var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Injectable } from '@angular/core';
var DriverSampleCSV = /** @class */ (function () {
    function DriverSampleCSV() {
    }
    DriverSampleCSV.prototype.getValues = function (emailValue, driverPincodeValue) {
        this.emailRequired = emailValue;
        this.isDriverPinCode = driverPincodeValue;
    };
    DriverSampleCSV.prototype.getHeaderOptions = function (data) {
        var driverOptions;
        driverOptions = {
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalseparator: '.',
            showLabels: true,
            showTitle: false,
            headers: getHeaders(data, this.isDriverPinCode, this.emailRequired)
        };
        return driverOptions;
    };
    DriverSampleCSV.prototype.getDataOption = function (domain) {
        if (domain === 'app.xquara.co') {
            var xquaraData = void 0;
            xquaraData = [
                {
                    name: 'Driver_name',
                    code: '965',
                    phone: '87654432',
                    email: 'email@gmail.com',
                    TeamId: '7204',
                    password: 'Xquara@123',
                    notes: 'Hi driver',
                    transportType: '2',
                    transportDesc: 'honda bike',
                    licencePlate: 5244,
                    kolor: 'red',
                    InsuranceExpiryDate: '2022-12-08 18:30:00.000Z'
                }
            ];
            if (this.isDriverPinCode) {
                Object.assign(xquaraData[0], { 'pincode': 560097 });
            }
            else {
                delete xquaraData[0]['pincode'];
            }
            return xquaraData;
        }
        else {
            var driverData = void 0;
            driverData = [
                {
                    name: 'ramachandra',
                    code: '91',
                    phone: '9030263984',
                    email: 'rcrmca1@gmail.com',
                    TeamId: '7204',
                    password: 'Reddy@123',
                    notes: 'Hi driver',
                    transportType: '2',
                    transportDesc: 'honda bike',
                    licencePlate: 5244,
                    kolor: 'red',
                    InsuranceExpiryDate: '2022-12-08 18:30:00.000Z'
                }
            ];
            if (this.isDriverPinCode) {
                Object.assign(driverData[0], { 'pincode': 560097 });
            }
            else {
                delete driverData[0]['pincode'];
            }
            return driverData;
        }
    };
    DriverSampleCSV = __decorate([
        Injectable()
    ], DriverSampleCSV);
    return DriverSampleCSV;
}());
export { DriverSampleCSV };
function getHeaders(title, isDriverPinCode, emailRequired) {
    var defaultHeaderArr;
    if (title === 'importOption') {
        defaultHeaderArr = ['Name*', 'Country_code*', 'Phone*', 'Email', 'TeamId*', 'Password*', 'Notes', 'Transport_type',
            'Transport_description', 'LicencePlate_Number', 'Color', 'InsuranceExpiryDate'];
        if (isDriverPinCode) {
            defaultHeaderArr.push('Pincode');
        }
        if (emailRequired) {
            defaultHeaderArr[3] = 'Email*';
        }
    }
    else {
        defaultHeaderArr = ['Driver_id', 'Name', 'Phone', 'Email_id', 'Team', 'Status', 'Notes', 'TransportType',
            'Transport_Description', 'licence_Plate', 'Color', 'InsuranceExpiryDate'];
        if (isDriverPinCode) {
            defaultHeaderArr.push('Pincode');
        }
    }
    return defaultHeaderArr;
}



//////////////////
// WEBPACK FOOTER
// ./src/app/driver/driverSampleCSV.ts
// module id = ./src/app/driver/driverSampleCSV.ts
// module chunks = main